export default "__VITE_ASSET__4d3a8820__"